import React from 'react';
import LinksCell from '@/components/table/LinksCell';
import { safeFormArray } from '../../state/state';

const FormObjectStringLinksCell = ({ field, item }) => (
  <LinksCell
    className={`aridhia-form-object-string-links-cell-${field.type}`}
    collapsing
    links={safeFormArray(item[field.name])}
  />
);

export default FormObjectStringLinksCell;
